import { WhatsappLogo } from "@phosphor-icons/react";

/**
 * Green pill CTA that opens WhatsApp with a pre-filled booking message.
 *
 * Props
 * -----
 * dispatcherName   : "Ralph" | "Charles"
 * dispatcherPhone  : E.164 or human-formatted number ("+231 77 768 9123")
 * lines            : array of "Label: value" strings to include in the body
 * subject          : short opener line (e.g. "New Airport Shuttle booking")
 * testId           : optional data-testid override
 * variant          : "primary" (solid green) | "ghost" (outline)
 */
export const WhatsAppBookingButton = ({
  dispatcherName,
  dispatcherPhone,
  lines = [],
  subject,
  testId = "whatsapp-booking-btn",
  variant = "primary",
}) => {
  if (!dispatcherPhone) return null;
  const digits = String(dispatcherPhone).replace(/[^\d]/g, "");
  if (!digits) return null;

  const opener = subject || `Hi ${dispatcherName || "team"}, I'd like help with a RideXelite booking`;
  const body = [opener, "", ...lines.filter(Boolean)].join("\n");
  const href = `https://wa.me/${digits}?text=${encodeURIComponent(body)}`;

  const base =
    "inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full text-sm font-semibold transition";
  const styles =
    variant === "ghost"
      ? "border border-[#25D366] text-[#25D366] hover:bg-[#25D366]/10"
      : "bg-[#25D366] text-black hover:brightness-110";

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      data-sound="coin"
      className={`${base} ${styles}`}
    >
      <WhatsappLogo weight="fill" size={18} />
      WhatsApp {dispatcherName || "us"} this booking
    </a>
  );
};

export default WhatsAppBookingButton;
